import React from "react";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
const GoogleStyle = [
  {
    featureType: "poi",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi.business",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "transit",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
];
const containerStyle = {
  width: "100%",
  height: "300px",
  left: "0%",
};
function animateMarkerTo(marker, newPosition) {
  var options = {
    duration: 500,
    easing: function (x, t, b, c, d) {
      // jquery animation: swing (easeOutQuad)
      return -c * (t /= d) * (t - 2) + b;
    },
  };

  window.requestAnimationFrame =
    window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.msRequestAnimationFrame;
  window.cancelAnimationFrame =
    window.cancelAnimationFrame || window.mozCancelAnimationFrame;

  // save current position. prefixed to avoid name collisions. separate for lat/lng to avoid calling lat()/lng() in every frame
  marker.AT_startPosition_lat = marker.getPosition().lat();
  marker.AT_startPosition_lng = marker.getPosition().lng();
  var newPosition_lat = newPosition.lat;
  var newPosition_lng = newPosition.lng;

  // crossing the 180° meridian and going the long way around the earth?
  if (Math.abs(newPosition_lng - marker.AT_startPosition_lng) > 180) {
    if (newPosition_lng > marker.AT_startPosition_lng) {
      newPosition_lng -= 360;
    } else {
      newPosition_lng += 360;
    }
  }

  var animateStep = function (marker, startTime) {
    var ellapsedTime = new Date().getTime() - startTime;
    var durationRatio = ellapsedTime / options.duration; // 0 - 1
    var easingDurationRatio = options.easing(
      durationRatio,
      ellapsedTime,
      0,
      1,
      options.duration,
    );

    if (durationRatio < 1) {
      marker.setPosition({
        lat:
          marker.AT_startPosition_lat +
          (newPosition_lat - marker.AT_startPosition_lat) * easingDurationRatio,
        lng:
          marker.AT_startPosition_lng +
          (newPosition_lng - marker.AT_startPosition_lng) * easingDurationRatio,
      });

      // use requestAnimationFrame if it exists on this browser. If not, use setTimeout with ~60 fps
      if (window.requestAnimationFrame) {
        marker.AT_animationHandler = window.requestAnimationFrame(function () {
          animateStep(marker, startTime);
        });
      } else {
        marker.AT_animationHandler = setTimeout(function () {
          animateStep(marker, startTime);
        }, 17);
      }
    } else {
      marker.setPosition(newPosition);
    }
  };

  // stop possibly running animation
  if (window.cancelAnimationFrame) {
    window.cancelAnimationFrame(marker.AT_animationHandler);
  } else {
    clearTimeout(marker.AT_animationHandler);
  }

  animateStep(marker, new Date().getTime());
}
function MyComponent({ Cordinates, Zoom, onMarkerMove, onMapClick, ApiKey }) {
  const markerRef = React.useRef(null);
  const [center, setCenter] = React.useState(null);
  const [map, setMap] = React.useState(null);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: ApiKey,
  });

  const handleBoundsChanged = () => {
    if (isLoaded) {
      if (map !== null) {
        let mapCenter = map.center; //get map center
        let latlng = { lat: mapCenter.lat(), lng: mapCenter.lng() };
        onMarkerMove(latlng);
        setCenter({
          lat: mapCenter.lat(),
          lng: mapCenter.lng(),
        });
      }
    }
  };
  const onLoad = React.useCallback(function callback(map) {
    // This is just an example of getting and using the map instance!!! don't just blindly copy!

    const bounds = new window.google.maps.LatLngBounds(Cordinates);

    map.fitBounds(bounds);

    setMap(map);
    HideMapData();
    var listener = window.google.maps.event.addListener(
      map,
      "idle",
      function () {
        map.setZoom(Zoom);

        HideMapData();
        window.google.maps.event.removeListener(listener);
      },
    );
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);
  const onClick = React.useCallback((event) => {
    let latlng = { lat: event.latLng.lat(), lng: event.latLng.lat() };
    onMarkerMove(latlng);
    animateMarkerTo(markerRef.current.marker, latlng, event);
  }, []);

  const HideMapData = () => {
    let gmnoprint = document.getElementsByClassName("gmnoprint");
    if (gmnoprint) {
      for (let i = 0; i < gmnoprint.length; i++) {
        gmnoprint[i].style.display = "none";
      }
    }
    let gmsvpc = document.getElementsByClassName("gms-vpc");
    if (gmsvpc) {
      for (let i = 0; i < gmsvpc.length; i++) {
        gmsvpc[i].style.display = "none";
      }
    }
    let gmfullscreencontrol = document.getElementsByClassName(
      "gm-fullscreen-control",
    );
    if (gmfullscreencontrol) {
      for (let i = 0; i < gmfullscreencontrol.length; i++) {
        gmfullscreencontrol[i].style.display = "none";
      }
    }
    let gmstylecc = document.getElementsByClassName("gm-style-cc");
    if (gmstylecc) {
      for (let i = 0; i < gmstylecc.length; i++) {
        gmstylecc[i].style.display = "none";
      }
    }
  };
  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={Cordinates}
      zoom={Zoom}
      onLoad={onLoad}
      onUnmount={onUnmount}
      // onClick={(e) => {
      //   onClick(e);
      //   // onMapClick(e);
      // }}
      onBoundsChanged={() => {
        handleBoundsChanged();
      }}
      initialCenter={Cordinates}
      onZoomChanged={() => {
        HideMapData();
      }}
      options={{
        mapTypeControl: false,
        styles: GoogleStyle,
        scaleControl: false,

        navigationControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        zoomControl: false,
      }}
    >
      <Marker
        position={center}
        ref={markerRef}
        icon={{
          // url: require("./images/GoogleMarker.png"),
          url: require("./images/GoogleMarker3.png"),
        }}

        // animation={window.google.maps.Animation.BOUNCE}
      ></Marker>
    </GoogleMap>
  ) : (
    <></>
  );
}

export default React.memo(MyComponent);
